import(/* webpackMode: "eager" */ "/tmp/build-6a61356399f1da00140f2476/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-6a61356399f1da00140f2476/src/app/components/ScrollAnimator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-6a61356399f1da00140f2476/src/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-6a61356399f1da00140f2476/src/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build-6a61356399f1da00140f2476/src/components/ui/AppImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-6a61356399f1da00140f2476/src/components/ui/AppLogo.tsx");
